<template>
	<div v-loading="loading">
		<div class="wrap">
			<div class="container lnb">
				<div class="contents_wrap">
					<div class="contents">
						<div class="title">
							test
						</div>
						<div class="table_wrap">
							<div class="c_table_wrap table_search_wrap">
								<table>
                                    <colgroup>
                                        <col width="200px;">
                                        <col width="">
                                    </colgroup>
									<tbody>
									<tr>
										<td class="c_t_title">Query Input</td>
										<td>
											<div class="search">
												<el-select class="table_s_select" v-model="searchInputOption">
													<el-option v-for="option in searchInputOptions" :key="option.value" :value="option.value" :label="option.label"></el-option>
												</el-select>
												<el-input class="table_s_input" v-model="searchInput"></el-input>
												<el-button @click="setFilter(searchInputOption, searchInput, 'query', 'searchInput')">
													검색
												</el-button>
											</div>

										</td>
									</tr>
									<tr>
										<td class="c_t_title">Match Radio</td>
										<td>
											<div>
												<el-radio-group v-model="filterDelete" @change="setFilter('i_is_delete', filterDelete, 'match')">
													<el-radio :label="''">전체</el-radio>
													<el-radio :label="'0'">미삭제</el-radio>
													<el-radio :label="'1' ">삭제</el-radio>
												</el-radio-group>
											</div>
										</td>
									</tr>
									<tr>
										<td class="c_t_title">Range Date</td>
										<td>
											<div>
												<el-date-picker
														v-model="filterDate"
														type="daterange"
														range-separator="~"
														value-format="yyyy-MM-dd"
														start-placeholder="시작날짜"
														end-placeholder="끝 날짜"
														@change="setFilter('created_at', filterDate, 'between')"
												>
												</el-date-picker>
											</div>
										</td>
									</tr>
									<tr>
										<td class="c_t_title">Range Input</td>
										<td>
											<div class="num_length">
												<el-input v-model="filterPrice[0]" type="number"
												></el-input>
												<span class="">
													원
													~
												</span>
												<el-input v-model="filterPrice[1]" type="number"
												></el-input>
												<span>
													원
												</span>
												<el-button @click="setFilter('i_price', filterPrice, 'between')">
													검색
												</el-button>
											</div>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div>
								<span>sort : </span>
								<el-select v-model="filterSet.sort.key" @change="setSort(filterSet.sort.key, filterSet.sort.order)">
									<el-option v-for="sort in sortClass.getterSortKeys()" :key="`sortKey${sort.value}`" :value="sort.value" :label="sort.label"></el-option>
								</el-select>
								<el-select v-model="filterSet.sort.order" @change="setSort(filterSet.sort.key, filterSet.sort.order)">
									<el-option :value="'desc'" :label="'내림차순'"></el-option>
									<el-option :value="'asc'" :label="'오름차순'"></el-option>
								</el-select>
							</div>
							<div>
								<span>pageSize : </span>
								<el-select v-model="filterSet.page.size" @change="setPage(filterSet.page.size, 'size')">
									<el-option :value="10" :label="'10개씩'"></el-option>
									<el-option :value="20" :label="'20개씩'"></el-option>
									<el-option :value="30" :label="'30개씩'"></el-option>
								</el-select>
							</div>
							<el-pagination v-if="filterSet.page.total > 0"
								:page-size="filterSet.page.size"
								:current-page.sync="filterSet.page.page"
								:pager-count="11"
								layout="prev, pager, next"
								:total="filterSet.page.total"
								@current-change="setPage(filterSet.page.page, 'page')"
							></el-pagination>
							{{filterSet}} <br>
							<div v-for="data in listData">
								{{data.i_idx}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
const filterConfig = {
	'i_name': { //상품이름
		type: 'query',
		classname: 'searchInput',
	},
	'i_sku': { //상품코드
		type: 'query',
		classname: 'searchInput',
	},
	'i_model': { //관리코드
		type: 'query',
		classname: 'searchInput',
	},
	'created_at': { //등록일
		type: 'between',
		classname: 'filterDate',
	},
	'i_price': { //가격
		type: 'between',
		classname: 'filterPrice',
	},
	i_is_delete: { //삭제 여부
		type: 'match',
		classname: 'filterDelete'
	}
};
const elasticUrl = 'http://search-eot-pub-kckftkvfhiytst7hsmwwvzqxv4.ap-northeast-2.es.amazonaws.com';
const elasticIndex = elasticOption.index;
const elasticType = elasticOption.type

import filterMixin from "@/mixins/filterMixins";
import {elasticOption} from "@/api/config";
import {initElastic, getElasticData, clearScroll} from "@/mixins/testElastic/elasticsearch"
export default {
	name: "NewFilterTest",
	mixins: [ filterMixin ],
	components: {
	},
	props: {

	},
	data() {
		return{
			searchInputOptions: [
				{
					label: '상품명',
					value: 'i_name'
				},
				{
					label: '상품코드',
					value: 'i_sku'
				},
				{
					label: '관리코드',
					value: 'i_model'
				},
			],
			searchInputOption: 'i_name',
			searchInput: '',
			filterDelete: '',
			filterDate: ['', ''],
			filterPrice: ['', ''],

			listData: [],
			loading: false,
		}
	},
	beforeRouterEnter() {},
	created() {
		initElastic(elasticUrl, elasticIndex, elasticType);
		this.setFilterConfig(filterConfig)
		this.setParserType('url', this.$route.fullPath);
		// this.setParserType('vuex', this.$store.getters['common/getFilterSet']);

	},
	mounted() {
		let sortKeys = [
			{
				value: 'created_at',
				label: '회원가입일'
			},{
				value: 'mb_name',
				label: '이름'
			},{
				value: 'mb_nick',
				label: '닉네임'
			},
		];
		this.setSortKeys(sortKeys);
		// this.setPage(1000, 'total')
		// this.setParsingDataPageFilterSet();
		// this.setPage(7, 'page')
		this.getList(true);
	},
	beforeDestroy() {
		clearScroll();
	},
	destroyed() {},
	computed: {
	},
	methods:{
		getList(isFirst=false) {
			this.loading = true;
			let filterSet = this.$_.cloneDeep(this.getFilterSet());
			if(isFirst) {
				let parsingDataPage = this.getPasingDataPage();
				filterSet.page.page = parsingDataPage;
			}else if(this.isInitPage) {
				filterSet.page.page = 1;
			}
			getElasticData(filterSet).then(res => {
				this.listData = res.list;
				this.setPage(res.page.total, 'total');
				if(isFirst) {
					this.setParsingDataPageFilterSet();
				}else if(this.isInitPage) {
					this.setPage(filterSet.page.page, 'page');
				}

				this.loading = false;
			});
		},
	},
	watch: {
	},

}
</script>
